module.exports = __webpack_public_path__ + "static/media/create-page-wizard-1.e342a809.png";